import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题与热搜关键词
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">大家都在搜的热门漫画话题，看看读者们在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-[11px] text-foreground-500 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}